import { _ as _overArg } from './_overArg.mjs';

var overArg = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

export { _nativeKeys as _ };
